// CACHE BUST v6.1 - GroupCoachingBanner fully removed - Contemporary design with scroll animations
import React from 'react';
import { Link } from 'react-router-dom';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver.jsx';
function About() {
  const [headerRef, headerVisible] = useIntersectionObserver({
    threshold: 0.2
  });
  const [contentRef1, content1Visible] = useIntersectionObserver({
    threshold: 0.2
  });
  const [accentBoxRef, accentBoxVisible] = useIntersectionObserver({
    threshold: 0.3
  });
  const [taglineRef, taglineVisible] = useIntersectionObserver({
    threshold: 0.3
  });
  const [imageRef, imageVisible] = useIntersectionObserver({
    threshold: 0.2
  });
  const [introRef, introVisible] = useIntersectionObserver({
    threshold: 0.2
  });
  return <section id="about" className="py-20 md:py-16 bg-white mt-0 mb-0 ml-0 mr-0 pl-0 pr-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content - Bold Format with Animations */}
        <div className="max-w-4xl mx-auto mb-20">
          <div className="space-y-8 text-gray-900">
            
            {/* Section 1: Opening Bold Statement with Scroll Animation */}
            <div ref={headerRef} className={`space-y-6 transition-all duration-800 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-light text-sage-600 mb-6 text-balance">
                YOU WERE TAUGHT TO BE THE "NICE GIRL" WHO KEEPS THE PEACE.
              </h2>
              
              <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                The kind of "nice girl" who makes sure everyone else feels okay... while running on empty herself.
              </p>
              
              <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                You are <span className="italic">sometimes still</span> saying yes when you want to say no.<br />
                You are <span className="italic">sometimes still</span> staying silent when you want to speak your mind.
              </p>
              
              <p className="text-base text-sage-600 italic leading-relaxed pl-6">
                These are not personal failings.. these are brilliant strategies to create safety for yourself in a complex situation where all of you is not being honored and supported.
              </p>
              
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed"></p>
              
              <div ref={accentBoxRef} className={`bg-cream-50/50 pl-8 border-l-4 border-sage-300 py-6 space-y-4 rounded-r-2xl shadow-sm transition-all duration-800 ${accentBoxVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
                <p className="text-base text-gray-600 leading-relaxed">
                  You don't need others to <strong>like</strong> you...<br />
                  You want them to <strong>respect</strong> you.
                </p>
                
                <p className="text-base text-gray-600 leading-relaxed">
                  You're done being someone you're not.<br />
                  You're done pretending.
                </p>
              </div>
              
              <p className="text-lg md:text-xl font-normal leading-relaxed pt-2 text-gray-600">
                You want to show up in ways that are <span className="italic">fully you.</span> All of you.
              </p>
              
              <div className="space-y-5 pt-2">
                <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                  <strong className="text-gray-600">{"You're here to reclaim your life, each part of it, one at a time."}</strong>
                </p>
                
                <p className="text-base text-gray-600 leading-relaxed pl-6">
                  <span className="italic">Even with</span> the guilt you feel.<br />
                  <span className="italic">Even with</span> the anxiety you're facing right now.
                </p>
                
                <p className="text-base text-gray-600 leading-relaxed pl-6">
                  Without burning bridges.<br />
                  Without becoming someone you're not.
                </p>
              </div>
              
              {/* Aspirational Tagline with Animation */}
              <p ref={taglineRef} className="text-base md:text-lg italic leading-relaxed pt-8 text-center bg-[#f9f9f9] text-gray-500 p-6 rounded-xl">{"Imagine waking up free. Free from the pull to shrink, explain, or make others comfortable. Because real freedom isn't loud ...it's the quiet confidence of being yourself without apology."}</p>
              
              {/* Image and Intro Section */}
              <div className="grid md:grid-cols-2 gap-8 mt-12 items-center">
                {/* Image on Left */}
                <div ref={imageRef} className={`relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-800 group ${imageVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
                  <img alt="Yasi Philipos" className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700" src="https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/user_33tbl7B6e1bXN6KW4wjrevvqrth/cmhd1gtfc0001vb0yeeofdn9z/images/yasi-headshots-072121-27-1-xflteva9dag.jpg" />
                  <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
                    <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
                    <span className="hidden drop-shadow-md group-hover/attribution:block">
                      Image on{' '}
                      <a href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
                      color: '#fff',
                      textDecoration: 'none'
                    }} data-tracking-id="link-45a9e28446317c9a">
                        Unsplash
                      </a>{' '}
                      by{' '}
                      <a href="https://unsplash.com/@silverkblack?utm_source=makerdevi&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
                      color: '#fff',
                      textDecoration: 'none'
                    }} data-tracking-id="link-6a9dd50ac0dc211c">
                        Vitaly Gariev
                      </a>
                    </span>
                  </span>
                </div>
                
                {/* Text and CTA on Right */}
                <div className="space-y-6">
                  <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-700">{"Hello, I'm Yasmin"}</h3>
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed">I’m a therapist and coach helping women stop people-pleasing, trust their own needs, and show up more authentically in their relationships and lives. I offer in-person therapy in Redwood City, serving the South Bay, and online therapy throughout California.</p>
                  <a href="/about-me" className="inline-flex items-center px-6 py-3 bg-sage-600 text-white font-medium rounded-lg hover:bg-sage-700 transition-colors duration-300" data-tracking-id="link-ea4d57c6f2d9a75d">
                    Learn More About Me
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-sage-300 w-24 mx-0 my-12"></div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-8 text-gray-900">
            {/* Body Wisdom Quote */}
            <div className="relative py-12 px-4 sm:px-6 lg:px-8 my-8 overflow-hidden rounded-2xl">
              {/* Background with gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#8B9D83]/10 via-[#F5F1ED]/50 to-[#8B7355]/5"></div>
              
              {/* Decorative elements */}
              <div className="absolute top-0 left-0 w-64 h-64 bg-[#8B9D83]/5 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#8B7355]/5 rounded-full blur-3xl"></div>
              
              <div className="relative text-center max-w-5xl mx-auto">
                <blockquote className="space-y-4">
                  <p className="text-2xl sm:text-3xl lg:text-4xl font-glacial font-light text-gray-800 leading-relaxed inline-block">
                    That tightness in your chest. The knot in your stomach. The tension in your shoulders.
                  </p>
                  <p className="text-2xl sm:text-3xl lg:text-4xl font-glacial font-light text-gray-800 leading-relaxed inline-block">{"These aren't inconveniences to push through, they're your body's ancient wisdom guiding you."}</p>
                </blockquote>
              </div>
            </div>




          </div>
        </div>

      </div>
    </section>;
}
export default About;